import React from "react";
import "./CardEvento.css";

// Componente Badge para los Tags (Reutilizado de Grupos, ajustado para eventos)
function EventTagsBadge({ tags, attendees }) {
  // Colores para los tags circulares
  const coloresCirculos = ["#00C2FF", "#97C100", "#FF2D52"];

  const validTags = Array.isArray(tags) ? tags : [];

  return (
    <div className="event-meta-footer d-flex align-items-center mt-2">
      <span className="event-tags-badge-group me-2">
        {validTags.map((letra, idx) => (
          <span
            key={idx}
            className="badge-circulo"
            style={{
              backgroundColor: coloresCirculos[idx % coloresCirculos.length],
              marginRight: idx < validTags.length - 1 ? "-8px" : "0px",
              zIndex: 10 - idx,
              border: "2px solid #fff",
            }}
          >
            {letra}
          </span>
        ))}
      </span>
      <span className="event-attendees-text small text-muted ms-1 fw-bold">
        {attendees} asistentes
      </span>
    </div>
  );
}

/**
 * CardEvento: Muestra la información de un evento en formato horizontal 50/50.
 * @param {string} title - Título del evento
 * @param {string} date - Fecha del evento (ej: "15 de agosto 2023")
 * @param {string} time - Hora del evento (ej: "18:40 pm")
 * @param {string} location - Ubicación/Dirección
 * @param {string[]} tags - Iniciales de los últimos asistentes (ej: ["I", "A", "E"])
 * @param {number} attendees - Número total de asistentes
 * @param {string} imageUrl - URL de la imagen del evento
 */
const CardEvento = ({
  title,
  date,
  time,
  location,
  tags,
  attendees,
  imageUrl,
  onViewDetail,
}) => {
  // Manejador de clic para ir al detalle (simulación)
  const handleViewDetail = () => {
    if (onViewDetail) {
      onViewDetail(/* Pasar ID del evento aquí */);
    } else {
      console.log(`Ver detalles del evento: ${title}`);
    }
  };

  return (
    <div
      className="event-card d-flex flex-column flex-md-row shadow-sm"
      onClick={handleViewDetail}
    >
      {/* Imagen del Evento */}
      <div className="event-card-image-wrapper w-md-50">
        <img
          src={
            imageUrl ||
            "https://via.placeholder.com/400x300/f8f9fa/525252?text=Evento"
          }
          alt={title}
          className="event-card-img"
        />
      </div>
      {/* Contenido del Evento */}
      <div className="event-card-content w-100 w-md-50 p-3 d-flex flex-column justify-content-between">
        {/* Fecha y Hora */}
        <div className="event-datetime-meta mb-2">
          <span className="event-date fw-bold">{date}</span>
          <span className="event-separator mx-2">|</span>
          <span className="event-time">{time}</span>
        </div>
        {/* Título */}
        <div className="event-card-title fw-bold mb-2">{title}</div>
        {/* Ubicación */}
        <div className="event-location-meta text-muted mb-3">{location}</div>
        {/* Tags y Asistentes */}
        <EventTagsBadge tags={tags} attendees={attendees} />
      </div>
    </div>
  );
};

export default CardEvento;
